import News from '../resources/News';

export default News;
